// extracted by mini-css-extract-plugin
export default {"wrapper":"accordion-controlled-module--wrapper--a5d97"};